import { render, staticRenderFns } from "./alternativo.vue?vue&type=template&id=2800ad03"
import script from "./alternativo.vue?vue&type=script&lang=js"
export * from "./alternativo.vue?vue&type=script&lang=js"
import style0 from "./alternativo.vue?vue&type=style&index=0&id=2800ad03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports